import React, { useEffect, useState } from "react";
import { Form, Pagination } from "react-bootstrap";

export default function NavigationPagination({currentPage,lastPage,setPage, perPage, setPerPage}: {currentPage: number, lastPage: number, setPage: (page: number) => void, perPage: number, setPerPage: (perPage: number) => void}) {

    const [oldLastPage, setOldLastPage] = useState(0);

    useEffect(() => {
        if (currentPage > lastPage && oldLastPage !== lastPage) {
            setPage(1);
            setOldLastPage(lastPage);
        }else if (currentPage > lastPage && oldLastPage === lastPage) {
            setPage(lastPage);
        }
    }, [currentPage, lastPage, setPage, oldLastPage]);

    return (
        <nav className="list-pagination">
            <div className="pagination-actions">
                {currentPage > 1 && (
                    <Pagination.Prev as="a" className="btn btn-prev" title="Précédent" onClick={()=>{setPage(currentPage-1)}} >
                        <span className="icon"></span>
                        <span className="text">Précédent</span>            
                    </Pagination.Prev>
                )}
                <Pagination bsPrefix="pages" as="ul">
                    {currentPage > 1 &&
                        (<>
                            <Pagination.First linkClassName="btn btn-page"  className="page-first" onClick={()=>{setPage(1)}}>1</Pagination.First>
                            { currentPage > 2 &&
                            (<>
                                <Pagination.Ellipsis />
                                <Pagination.Item linkClassName="btn btn-page" className="page" onClick={()=>{setPage(currentPage-1)}}>{currentPage-1}</Pagination.Item>
                            </>)}
                        </>)
                    }
                    <Pagination.Item linkClassName="btn btn-page" className="page current" active>{currentPage}</Pagination.Item>
                    {currentPage < lastPage &&
                        (<>
                            {currentPage < lastPage-1 &&
                            (<>
                            <Pagination.Item linkClassName="btn btn-page" className="page" onClick={()=>{setPage(currentPage+1)}}>{currentPage+1}</Pagination.Item>
                            <Pagination.Ellipsis />
                            </>)}
                            <Pagination.Last linkClassName="btn btn-page"  className="page-first" onClick={()=>{setPage(lastPage)}}>{lastPage}</Pagination.Last>
                        </>)
                    }
                </Pagination>
                {currentPage < lastPage && (          
                    <Pagination.Next  as="a" className="btn btn-next" title="Suivant" onClick={()=>{setPage(currentPage+1)}}>
                        <span className="icon"></span>
                        <span className="text">Suivant</span>
                    </Pagination.Next>
                )}
            </div>
            <div className="pagination-parameters">
                <Form.Group className="form-group">
                    <Form.Label className="form-label">Nb. par page</Form.Label>
                    <Form.Select className="form-select" id="pagination-parameters-itemsPerPage-select" value={perPage} onChange={(e) => setPerPage(Number(e.target.value))} >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </Form.Select>
                </Form.Group>
            </div> 
        </nav>
    );
}